<div class="ap-container">
  <gstar-extended-editor
    #editor
    [content]="content()"
    [disableSaveButton]="!!disableSaveButton()"
    [canEdit]="canEditCountry()"
    [showReadOnlyLabel]="showReadOnlyLabel()"
    [allowInternalLinks]="true"
    (modeChange)="modeUpdate($event)"
    (dismiss)="cancelHandler()"
    (save)="saveHandler($event)">
    <ng-container toolbar>
      <ap-button
        btnType="secondary"
        [label]="'countryInformation.backToTaxNews' | translate"
        (click)="goBack()" />
    </ng-container>
    <ng-container after-toolbar-edit>
      <form [formGroup]="taxNewsForm" class="d-flex">
        <gstar-textfield
          class="col-8"
          formControlName="name"
          [messages]="message"
          [label]="'countryInformation.newsTitle' | translate" />
        @if (date().length !== 0) {
          <div class="col-4 ps-3">
            <gstar-datepicker
              [value]="date()"
              [isRequired]="true"
              formControlName="date"
              [label]="'shared.date' | translate" />
            @if (taxNewsForm.get('date')?.errors?.['dateRange']) {
              <div class="ap-field-validation-error">
                {{
                  'countryInformation.dateRangeError'
                    | translate: { minDate: minDateText }
                }}
              </div>
            }
          </div>
        }
      </form>
    </ng-container>
    <ng-container title-edit>
      <h2>
        @if (taxNewsId()) {
          {{ 'countryInformation.editTaxNews' | translate }}
        } @else {
          {{ 'countryInformation.addTaxNews' | translate }}
        }
      </h2>
    </ng-container>
    <ng-container title-readonly>
      {{ this.taxNews().name }}
    </ng-container>
  </gstar-extended-editor>
</div>
